<template>
<div class="input-upload">
    <div v-if="!file.name && !savedImg.length">
        <el-upload action="" drag :auto-upload="false" :on-change="handleChange" :limit="10" :show-file-list="false" accept="image/*,.pdf" ref="upload">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="24" r="24" fill="#F4F7FB" />
                <path d="M28.8006 24.8516V26.9848C28.8006 27.2677 28.6882 27.539 28.4882 27.739C28.2881 27.939 28.0168 28.0514 27.7339 28.0514H20.2669C19.984 28.0514 19.7127 27.939 19.5126 27.739C19.3126 27.539 19.2002 27.2677 19.2002 26.9848V24.8516" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M26.6675 21.1177L24.0008 18.4512L21.334 21.1177" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M24.001 18.4512V24.8508" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <p class="medium c-ndarkthree">Arraste e solte aqui ou <span :class="`c-${getPrimaryColor}five underline`">procure do seu computador.</span></p>
            <h6 slot="tip" class="c-nmidone regular">
                Formatos aceitos: .pdf, .jpeg, .png, .doc e .xml. <br> Tamanho máximo: 1 MB.
            </h6>
        </el-upload>
    </div>
    <span class="d-flex align-items-center justify-content-between list-upload" v-if="file.name && !savedImg.length">
        <!-- {{file }} -->
        <div class="d-flex align-items-center pointer">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="20" fill="#F4F7FB" />
                <path d="M20.667 13.334H16.0003C15.6467 13.334 15.3076 13.4745 15.0575 13.7245C14.8075 13.9746 14.667 14.3137 14.667 14.6673V25.334C14.667 25.6876 14.8075 26.0267 15.0575 26.2768C15.3076 26.5268 15.6467 26.6673 16.0003 26.6673H24.0003C24.3539 26.6673 24.6931 26.5268 24.9431 26.2768C25.1932 26.0267 25.3337 25.6876 25.3337 25.334V18.0007L20.667 13.334Z" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M20.667 13.334V18.0007H25.3337" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="ml-4">
                <p class="c-ndarkfour medium">
                    {{ about ? 'Sobre o sacado' : 'Logo do sacado' }}
                </p>
                <div class="d-flex">
                    <p class="c-ndarkfour mb-0">
                        <!-- {{ file.name.length > 25 ? `${file.name.slice(0, 24)}...` : file.name }} -->
                        {{ file.name }}
                    </p>
                    <h6 class="c-nmidone regular ml-2 mb-0">( {{ (file.size/1000).toFixed(2) }} KB)</h6>
                </div>
            </div>
        </div>
        <!-- <div class="d-flex align-items-center">
            <Button @click="replaceFile" color="grey" type="outline">
                <Upload color="grey"/>Anexar
            </Button>
        </div> -->
        <div class="d-flex align-items-center">
            <!-- EYE -->
            <Button icon color="grey" type="outline" @click="previewFile(file)">
                <Eye color="#A1A8B8" size="16" />
            </Button>

            <!-- DELETE -->
            <Button class="ml-2" icon color="red" type="outline" @click="removeFile()">
                <Trash color="#E54949" size="16" />
            </Button>
        </div>
    </span>
    <span class="d-flex align-items-center justify-content-between list-upload" v-else-if="savedImg.length">
        <!-- {{file }} -->
        <div class="d-flex align-items-center pointer">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="20" fill="#F4F7FB" />
                <path d="M20.667 13.334H16.0003C15.6467 13.334 15.3076 13.4745 15.0575 13.7245C14.8075 13.9746 14.667 14.3137 14.667 14.6673V25.334C14.667 25.6876 14.8075 26.0267 15.0575 26.2768C15.3076 26.5268 15.6467 26.6673 16.0003 26.6673H24.0003C24.3539 26.6673 24.6931 26.5268 24.9431 26.2768C25.1932 26.0267 25.3337 25.6876 25.3337 25.334V18.0007L20.667 13.334Z" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M20.667 13.334V18.0007H25.3337" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <div class="ml-4">
                <p class="c-ndarkfour medium">
                    {{ about ? 'Sobre o sacado' : 'Logo do sacado' }}
                </p>
                <div class="d-flex">
                    <p class="c-ndarkfour mb-0">
                        {{ fileName }}
                    </p>
                    <!-- <h6 class="c-nmidone regular ml-2 mb-0">( {{ (file.size/1000).toFixed(2) }} KB)</h6> -->
                </div>
            </div>
        </div>
        <!-- <div class="d-flex align-items-center">
            <Button @click="replaceFile" color="grey" type="outline">
                <Upload color="grey"/>Anexar
            </Button>
        </div> -->
        <div class="d-flex align-items-center">
            <!-- EYE -->
            <Button icon color="grey" type="outline" @click="previewSavedFile(savedImg)">
                <Eye color="#A1A8B8" size="16" />
            </Button>

            <!-- DELETE -->
            <Button class="ml-2" icon color="red" type="outline" @click="removeFile()">
                <Trash color="#E54949" size="16" />
            </Button>
        </div>
    </span>
</div>
</template>

<script>
import Eye from '@/components/icons/Eye'
import Trash from '@/components/icons/Trash'
//import Upload from '@/components/icons/Upload.vue';
export default {
    props: {
        img: {
            default: ''
        },
        about: {
            default: false
        }
    },
    components: {
        //Upload,
        Eye,
        Trash
    },
    data() {
        return {
            file: {},
            savedImg: ''
        };
    },
    methods: {
        removeFile() {
            this.file = {}
            this.savedImg = ''
            this.$emit('delete', '')
        },
        previewSavedFile(file) {
            window.open(`${process.env.VUE_APP_ROOT_API}/${file}`)
        },
        previewFile(file) {
            const fileURL = URL.createObjectURL(file.raw);
            window.open(fileURL);
        },
        toBase64: file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }),
        async handleChange(uploadedFile) {
            this.file = uploadedFile
            this.savedLogo = ''
            const base64File = await this.toBase64(uploadedFile.raw)
            const base64Header = base64File.indexOf(',') + 1
            const fileData = {
                name: uploadedFile.name,
                file: base64File.slice(base64Header , base64File.length)
            }
            this.$emit('change', fileData)
        },
        replaceFile() {
            this.file = {
                name: '',
                file: ''
            }
            this.savedImg = ''
            this.$emit('change', this.file)
        }
    },
    watch: {
        img(val) {
            this.savedImg = val
        }
    },
    computed: {
        filePath() {
            if (this.file.raw) {
                return URL.createObjectURL(this.file.raw)
            } else {
                return ''
            }
        },
        logoPath() {
            if (this.savedLogo.length) return `${process.env.VUE_APP_ROOT_API}/${this.savedLogo}`
            return ''
        },
        fileName() {
            if (this.savedImg.length) {
                const logoPathSplited =  this.savedImg.split('/')
                return logoPathSplited[logoPathSplited.length - 1]
            }
            return ''
        }
    },
    created() {
        if (this.img) {
            this.savedImg = this.img
        } else {
            this.savedImg = ''
        }
    }
};
</script>